import classNames from "classnames";
import React, { ReactNode } from "react";
import { Divider, NavigationBarButton, Text } from "@merge-api/merge-javascript-shared";
import { useHistory, useLocation } from "react-router-dom";

export interface Subtab {
  /**
   * If provided, a react element icon to show to the left of the label
   */
  icon?: React.ReactElement;
  label: string;
  destination?: string | { pathname: string; params: string };
  divider?: boolean;
  disabled?: boolean;
  disabled_tip_message?: string;
  header?: boolean;
}

interface Props {
  subtabs?: Array<Subtab>;
  children: ReactNode;
}

const SubLeftNavigationBar = ({ subtabs }: { subtabs?: Array<Subtab> }) => {
  const history = useHistory();
  const location = useLocation();

  return (
    <div className="flex flex-col">
      {subtabs &&
        subtabs.map((subtab) => {
          return (
            <>
              {subtab.divider && <Divider className="my-3" />}

              {subtab.destination && (
                <NavigationBarButton
                  className={classNames("nav-link sub-nav-link", subtab.disabled && "disabled")}
                  onClick={() => {
                    if (subtab.destination) {
                      history.push(
                        typeof subtab.destination === "string"
                          ? subtab.destination
                          : subtab.destination.pathname
                      );
                    }
                  }}
                  selected={(() => {
                    if (!subtab.destination) return false;
                    if (typeof subtab.destination === "string") {
                      return location.pathname === subtab.destination;
                    }
                    return location.pathname === subtab.destination.pathname;
                  })()}
                >
                  {subtab.icon}
                  {subtab.label}
                </NavigationBarButton>
              )}
              {subtab.header && (
                <div className="px-[13px] py-2">
                  <Text variant="pre-title" className="mb-1.5 text-gray-40">
                    {subtab.label}
                  </Text>
                </div>
              )}
            </>
          );
        })}
    </div>
  );
};

const SubLeftNavigationContainer = ({ subtabs, children }: Props) => (
  <div className="w-full grid grid-cols-6 gap-6">
    <div className="col-span-1">
      <SubLeftNavigationBar subtabs={subtabs} />
    </div>
    <div className="col-span-5">{children}</div>
  </div>
);

export default SubLeftNavigationContainer;
